<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc" id="_idContainer005" role="doc-toc">
<p class="TOCtitle">Contents</p>
<p class="TOCitem"><a href="#/Prologue#_idTextAnchor000">PROLOGUE</a></p>
<p class="TOCitem"><a href="#/Chapter_One#_idTextAnchor001">CHAPTER ONE</a></p>
<p class="TOCitem"><span href="#/Chapter_Two#_idTextAnchor002" title="Link target outside of Sample">CHAPTER TWO</span></p>
<p class="TOCitem"><span href="#/Chapter_Three#_idTextAnchor003" title="Link target outside of Sample">CHAPTER THREE</span></p>
<p class="TOCitem"><span href="#/Chapter_Four#_idTextAnchor004" title="Link target outside of Sample">CHAPTER FOUR</span></p>
<p class="TOCitem"><span href="#/Chapter_Five#_idTextAnchor005" title="Link target outside of Sample">CHAPTER FIVE</span></p>
<p class="TOCitem"><span href="#/Chapter_Six#_idTextAnchor006" title="Link target outside of Sample">CHAPTER SIX</span></p>
<p class="TOCitem"><span href="#/Chapter_Seven#_idTextAnchor007" title="Link target outside of Sample">CHAPTER SEVEN</span></p>
<p class="TOCitem"><span href="#/Chapter_Eight#_idTextAnchor008" title="Link target outside of Sample">CHAPTER EIGHT</span></p>
<p class="TOCitem"><span href="#/Chapter_Nine#_idTextAnchor009" title="Link target outside of Sample">CHAPTER NINE</span></p>
<p class="TOCitem"><span href="#/Epilogue#_idTextAnchor010" title="Link target outside of Sample">EPILOGUE</span></p>
<p class="TOCitem"><span href="#/Excerptone#_idTextAnchor011" title="Link target outside of Sample">EXCERPT FROM <i>ONE NIGHT ON THE VIRGIN’S TERMS</i> BY MELANIE MILBURNE</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?5ec873cb